import { uniqBy, cloneDeep, findKey, pick } from "lodash";
import {
  ADD_PAGE_DATA,
  ADD_CDP_PAGE_DATA,
  ADD_CDP_PAGE_PRODUCTS,
} from "../actions/page-data-actions";
import { SET_PRODUCT } from "@lululemon/ecom-pdp/src/store/actions/pdp-actions";
import { setProduct } from "@lululemon/ecom-pdp/src/store/reducers/pdp";

const pages = (state = {}, action) => {
  // if page has error or lacks data, we don't want to cache it in the redux tree
  if (!action.data || action.data?.error) {
    return state;
  }
  switch (action.type) {
    case ADD_CDP_PAGE_DATA: {
      const newState = cloneDeep(state);
      newState[action.path] = action.data.cdpData;
      newState[action.path].contentfulData = action.data.contentfulData;
      newState[action.path].featuredCategories =
        action.data.seoFeaturedCategoryCDP || {};
      return newState;
    }
    // ignoring this case for now until I understand how to test it
    /* istanbul ignore next */
    case ADD_CDP_PAGE_PRODUCTS: {
      const newState = cloneDeep(state);
      let newPage = newState[action.path] || {};
      newPage = {
        ...newPage,
        ...pick(action.data, [
          "results",
          "lazyLoadIndex",
          "bopisLazyLoadIndex",
          "storeInfo",
        ]),
      };
      newPage.onlyStore = !!action.data.onlyStore;
      newPage.bopisProducts = uniqBy(
        [
          ...(newPage.bopisProducts || []),
          ...(action.data.bopisProducts || []),
        ],
        "repository-id"
      );
      newPage.products = uniqBy(
        [...(newPage.products || []), ...(action.data.products || [])],
        "repository-id"
      );
      newPage.skus = {
        ...newPage.skus,
        ...action.data?.skus,
      };
      newState[action.path] = newPage;
      return newState;
    }
    case ADD_PAGE_DATA: {
      const processedData = cloneDeep(action.data);
      if (processedData.data) {
        processedData.data = setProduct(action.data.data);
      }
      const newState = cloneDeep(state);
      newState[action.path] = processedData;
      return newState;
    }
    case SET_PRODUCT:
      // Called whenever a size or color swatch is selected
      const productData = action.data?.data || {};
      const data = setProduct(productData, action.queryString);
      const { timestamp, loaded } = action.data;

      if (data["linked-products"]) {
        for (let i = 0; i < data["linked-products"].length; i++) {
          data["linked-products"][i] = setProduct(data["linked-products"][i]);
        }
      }

      const productId = data["product-summary"]?.["product-id"];
      const pathKey =
        action.path ||
        findKey(
          state,
          (page, pageKey) =>
            page.data &&
            page.data["product-summary"]?.["product-id"] === productId &&
            pageKey.includes(productId)
        );

      return {
        ...state,
        [pathKey]: {
          ...state[pathKey],
          data,
          timestamp,
          loaded,
        },
      };
    default:
      return state;
  }
};

export default pages;
